<template>
  <a-modal :title="title" :footer="null" v-model="visible" :width="520" class="date-model">
    <div class="date-model-row">
      <a-form-model>
        <a-row :gutter="24">
          <a-form-model-item label="起始日期">
            <a-date-picker v-model="startTimeMoment" format="YYYY-MM-DD" @change="changeStartTime"
              style="width: 290px" />
          </a-form-model-item>
        </a-row>
        <a-row :gutter="24">
          <a-form-model-item label="截止日期">
            <a-date-picker v-model="endTimeMoment" format="YYYY-MM-DD" :disabled-date="disabledDate"
              :disabled-time="disabledDateTime" @change="changeEndTime" style="width: 290px" />
          </a-form-model-item>
        </a-row>
      </a-form-model>
      <div class="btn-affirm">
        <a-button class="border-color" type="primary" @click="btnAffirm">确认</a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import moment from "moment";
import pick from "lodash.pick";
export default {
  name: "rankinglist",
  data() {
    return {
      visible: false,
      title: "记账科目明细账",
      startTime: null,
      endTime: null,
      startTimeMoment: null,
      endTimeMoment: null,
      accountingObj: {},
    };
  },
  methods: {
    moment,
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf("day");
    },

    disabledDateTime() {
      return {
        disabledHours: () => this.range(0, 24).splice(4, 20),
        disabledMinutes: () => this.range(30, 60),
        disabledSeconds: () => [55, 56],
      };
    },
    //   打开弹窗
    open(record) {
      this.visible = true;
      this.accountingObj = record;
      this.initTime(); // 初始化时间
    },
    initTime() {
      const endDate = this.getFormatDate(new Date()).substr(0, 11)
      const beginDate = this.getFormatDate(new Date(new Date() - 3600 * 1000 * 24 * 29)).substr(0, 11)
      this.startTime = beginDate
      this.endTime =  endDate
      this.endTimeMoment = moment(this.endTime)
      this.startTimeMoment = moment(this.startTime)
    },
    // 获取当前时间
    getFormatDate(date) {
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentDate = date.getFullYear() + '-' + month + '-' + strDate
      return currentDate
    },
    //   选择时间
    changeStartTime(date, dateString) {
      this.startTime = dateString;
      this.startTimeMoment = date;
    },
    changeEndTime(date, dateString) {
      this.endTime = dateString;
      this.endTimeMoment = date;
    },
    // 确认选择
    btnAffirm() {
      if (this.startTime == null) {
        this.$message.warning("请选择开始时间");
        return;
      } else if (this.endTime == null) {
        this.$message.warning("请选择结束时间");
        return;
      }
      this.visible = false;
      console.log(this.startTime,this.endTime)
      this.accountingObj.startTime = this.startTime;
      this.accountingObj.endTime = this.endTime;
      sessionStorage.setItem(
        "accountingObj",
        JSON.stringify(this.accountingObj)
      );
      this.$router.push({ path: "/statistics/finance/profitDetails" });
    },
  },
};
</script>

<style lang="scss">
.date-model {
  height: 340px;
  .ant-modal-content {
    height: 340px;
    .ant-form-item {
      display: flex;
      justify-content: center;
    }
    .ant-row {
      width: 100%;
      border-radius: 0 !important;
    }
    .btn-affirm {
      display: flex;
      justify-content: center;
      padding-top: 25px;
    }
    .border-color {
      width: 200px;
      margin: 0 auto;
    }
  }
}
</style>